import { Boxes, Inbox, Users, Wallet } from "lucide-react";

function Pill({ icon: Icon, label, value, testid }) {
  return (
    <div
      data-testid={testid}
      className="flex items-center gap-3 rounded-xl border border-zinc-800 bg-zinc-950/60 px-4 py-3 backdrop-blur-sm"
    >
      <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-zinc-800/80 text-zinc-300">
        <Icon className="h-4 w-4" />
      </div>
      <div>
        <div className="font-mono text-lg font-bold leading-none text-white">{value}</div>
        <div className="mt-1 text-[10px] font-medium uppercase tracking-[0.18em] text-zinc-500">{label}</div>
      </div>
    </div>
  );
}

export function ControlHero({ tasks = [], portalCount, totals = {}, userName, t }) {
  const attention = tasks.reduce((s, x) => s + (x.count || 0), 0);
  const clear = attention === 0;
  const glow = clear ? "#10b981" : "#f59e0b";

  return (
    <div
      data-testid="control-hero"
      className="relative overflow-hidden rounded-2xl border border-zinc-800 bg-zinc-900 p-6 lg:p-8"
    >
      <div
        className="pointer-events-none absolute -right-16 -top-28 h-72 w-72 rounded-full opacity-25 blur-3xl"
        style={{ background: glow }}
      />
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.04]"
        style={{ backgroundImage: "radial-gradient(#fff 1px, transparent 1px)", backgroundSize: "22px 22px" }}
      />
      <div className="relative flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
        <div className="min-w-0">
          <div className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.22em] text-zinc-500">
            <span
              className="h-2 w-2 rounded-full"
              style={{ background: glow, boxShadow: `0 0 12px ${glow}` }}
            />
            {t("control.commandCenter")}
          </div>
          <h1
            data-testid="control-hero-title"
            className="mt-4 font-heading text-3xl font-black tracking-tight text-white lg:text-4xl"
          >
            {clear ? (
              t("control.allClear")
            ) : (
              <>
                <span style={{ color: glow }}>{attention}</span> {t("control.needsAttention")}
              </>
            )}
          </h1>
          <p className="mt-2 text-sm text-zinc-400">
            {userName ? `${userName} · ` : ""}
            {clear ? t("task.emptySub") : t("control.todaySub")} · {portalCount} {t("nav.portals")}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:flex">
          <Pill icon={Boxes} label={t("kpi.providers")} value={(totals.providers ?? 0).toLocaleString("de-CH")} testid="hero-pill-providers" />
          <Pill icon={Inbox} label={t("stat.open_inquiries") || t("kpi.inquiries7d")} value={(totals.open ?? 0).toLocaleString("de-CH")} testid="hero-pill-open" />
          <Pill icon={Users} label={t("control.totalUsers")} value={(totals.users ?? 0).toLocaleString("de-CH")} testid="hero-pill-users" />
          <Pill icon={Wallet} label={t("kpi.revenue")} value={`CHF ${(totals.revenue ?? 0).toLocaleString("de-CH")}`} testid="hero-pill-revenue" />
        </div>
      </div>
    </div>
  );
}
